import {ConfigProvider} from 'antd';
import en from 'antd/es/locale/en_US';
import es from 'antd/es/locale/es_ES';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {createContext, useContext, useEffect, useState} from 'react';
import {I18nextProvider} from 'react-i18next';

import {i18n} from '@/settings';

const InternationalizationContext = createContext();

const ANT_LOCALE = {
  es,
  en,
};

const getSimpleLocale = (lng) => lng.split('-')[0];


function InternationalizationProvider({children}) {
  const [locale, setLocale] = useState(getSimpleLocale(i18n.language));
  useEffect(() => {
    i18n.subscribe(lng=> {
      const momentLng = getSimpleLocale(lng);
      moment.locale(momentLng);
      setLocale(momentLng);
    });
  }, []);

  const validateMessages = i18n.t('validateMessages', { returnObjects: true });

  return (
    <InternationalizationContext.Provider value={{
      locale
    }}>

      <I18nextProvider i18n={i18n}>
        <ConfigProvider locale={ANT_LOCALE[locale]}  form={{ validateMessages }}>
          {children}
        </ConfigProvider>
      </I18nextProvider>
    </InternationalizationContext.Provider>
  );
}

function useInternationalization() {
  const context = useContext(InternationalizationContext);
  if (context === undefined) {
    throw new Error('useInternationalization must be used within a InternationalizationProvider');
  }
  const {
    locale
  } = context;

  return locale;
}

InternationalizationProvider.propTypes = {
  children: PropTypes.any
};


export {InternationalizationProvider, useInternationalization};
